module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('github-badge', {
    attrs: {
      "slug": "QingWei-Li/vue-trend"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Vue Trend")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('trend', {
    attrs: {
      "data": _vm.data,
      "gradient": [_vm.color1, _vm.color2, _vm.color3],
      "padding": _vm.padding,
      "radius": _vm.radius,
      "stroke-width": _vm.width,
      "stroke-linecap": _vm.linecap,
      "gradientDirection": _vm.gradientDirection,
      "auto-draw": "",
      "smooth": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "playground"
  }, [_c('vue-tabs', [_c('v-tab', {
    attrs: {
      "title": "Configure"
    }
  }, [_c('div', {
    staticClass: "settings-container"
  }, [_c('div', {
    staticClass: "settings-column"
  }, [_c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Gradient direction")]), _vm._v(" "), _c('group', {
    staticClass: "inline-radio"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradientDirection),
      expression: "gradientDirection"
    }],
    attrs: {
      "type": "radio",
      "id": "gd-top",
      "value": "top"
    },
    domProps: {
      "checked": _vm._q(_vm.gradientDirection, "top")
    },
    on: {
      "change": function($event) {
        _vm.gradientDirection = "top"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gd-top"
    }
  }, [_vm._v("top")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradientDirection),
      expression: "gradientDirection"
    }],
    attrs: {
      "type": "radio",
      "id": "gd-bottom",
      "value": "bottom"
    },
    domProps: {
      "checked": _vm._q(_vm.gradientDirection, "bottom")
    },
    on: {
      "change": function($event) {
        _vm.gradientDirection = "bottom"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gd-bottom"
    }
  }, [_vm._v("bottom")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradientDirection),
      expression: "gradientDirection"
    }],
    attrs: {
      "type": "radio",
      "id": "gd-left",
      "value": "left"
    },
    domProps: {
      "checked": _vm._q(_vm.gradientDirection, "left")
    },
    on: {
      "change": function($event) {
        _vm.gradientDirection = "left"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gd-left"
    }
  }, [_vm._v("left")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradientDirection),
      expression: "gradientDirection"
    }],
    attrs: {
      "type": "radio",
      "id": "gd-right",
      "value": "right"
    },
    domProps: {
      "checked": _vm._q(_vm.gradientDirection, "right")
    },
    on: {
      "change": function($event) {
        _vm.gradientDirection = "right"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gd-right"
    }
  }, [_vm._v("right")])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Gradient first color")]), _vm._v(" "), _c('v-swatches', {
    attrs: {
      "swatch-size": 18,
      "background-color": "#f7f7f7",
      "swatches": ['#b8f2e6', '#6fa8dc', '#42b983', '#3a86ff', '#2c3e50', '#000000', '#ffe74c', '#ffbe88', '#ff93df', '#f94144', '#d6d6d6'],
      "inline": ""
    },
    model: {
      value: (_vm.color1),
      callback: function($$v) {
        _vm.color1 = $$v
      },
      expression: "color1"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Gradient second color")]), _vm._v(" "), _c('v-swatches', {
    attrs: {
      "swatch-size": 18,
      "background-color": "#f7f7f7",
      "swatches": ['#b8f2e6', '#6fa8dc', '#42b983', '#3a86ff', '#2c3e50', '#000000', '#ffe74c', '#ffbe88', '#ff93df', '#f94144', '#d6d6d6'],
      "inline": ""
    },
    model: {
      value: (_vm.color2),
      callback: function($$v) {
        _vm.color2 = $$v
      },
      expression: "color2"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Gradient third color")]), _vm._v(" "), _c('v-swatches', {
    attrs: {
      "swatch-size": 18,
      "background-color": "#f7f7f7",
      "swatches": ['#b8f2e6', '#6fa8dc', '#42b983', '#3a86ff', '#2c3e50', '#000000', '#ffe74c', '#ffbe88', '#ff93df', '#f94144', '#d6d6d6'],
      "inline": ""
    },
    model: {
      value: (_vm.color3),
      callback: function($$v) {
        _vm.color3 = $$v
      },
      expression: "color3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "settings-column"
  }, [_c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Width")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 12,
      "interval": 0.1
    },
    model: {
      value: (_vm.width),
      callback: function($$v) {
        _vm.width = $$v
      },
      expression: "width"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Padding")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 12,
      "interval": 0.1
    },
    model: {
      value: (_vm.padding),
      callback: function($$v) {
        _vm.padding = $$v
      },
      expression: "padding"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Radius")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 12,
      "interval": 0.1
    },
    model: {
      value: (_vm.radius),
      callback: function($$v) {
        _vm.radius = $$v
      },
      expression: "radius"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Linecap")]), _vm._v(" "), _c('group', {
    staticClass: "inline-radio"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linecap),
      expression: "linecap"
    }],
    attrs: {
      "type": "radio",
      "id": "lc-butt",
      "value": "butt"
    },
    domProps: {
      "checked": _vm._q(_vm.linecap, "butt")
    },
    on: {
      "change": function($event) {
        _vm.linecap = "butt"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lc-butt"
    }
  }, [_vm._v("butt")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linecap),
      expression: "linecap"
    }],
    attrs: {
      "type": "radio",
      "id": "lc-round",
      "value": "round"
    },
    domProps: {
      "checked": _vm._q(_vm.linecap, "round")
    },
    on: {
      "change": function($event) {
        _vm.linecap = "round"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lc-round"
    }
  }, [_vm._v("round")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linecap),
      expression: "linecap"
    }],
    attrs: {
      "type": "radio",
      "id": "lc-square",
      "value": "square"
    },
    domProps: {
      "checked": _vm._q(_vm.linecap, "square")
    },
    on: {
      "change": function($event) {
        _vm.linecap = "square"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lc-square"
    }
  }, [_vm._v("square")])])])], 1)])])]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "title": "Code"
    }
  }, [_c('pre', {
    staticClass: "code-wrap"
  }, [_c('code', {
    staticClass: "code",
    domProps: {
      "innerHTML": _vm._s(_vm.code)
    }
  })])])], 1)], 1), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "headline"
  }, [_vm._v(" Simple, elegant spark lines for Vue.js "), _c('a', {
    attrs: {
      "href": "https://jsfiddle.net/nyh18bLq/"
    }
  }, [_vm._v("Live Demo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._v("Released under the "), _c('a', {
    attrs: {
      "href": "//github.com/QingWei-Li/vue-trend/blob/master/LICENSE"
    }
  }, [_vm._v("MIT")]), _vm._v(" license. "), _c('a', {
    attrs: {
      "href": "//github.com/QingWei-Li/vue-trend"
    }
  }, [_vm._v("View source.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a340e48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/home.vue
// module id = 82
// module chunks = 1